export const BASE_URL =
  "https://virtserver.swaggerhub.com/hanabyan/todo/1.0.0/to-do-list";
